import { register } from "@shopify/theme-sections";

register("product-wrapper-item-collection", {
  onLoad() {
    // let gridItem = document.querySelector(`[data-section-id="${this.id}"]`);
    // const gridWishlistButton = gridItem.querySelector(".wishlist-button");
    // gridWishlistButton.addEventListener("click", (e) => {
    //   e.preventDefault();
    //   console.log("wishlist clicked", this);
    // });
    // let gridItemWishlist = gridItem.querySelector("button");
    // if (gridItemWishlist) {
    // gridItemWishlist.addEventListener("click", (e) => {
    //   e.preventDefault();
    //   console.log("wishlist clicked", e);
    // });
    // }
    // document.querySelectorAll(".product-wrapper-item").forEach((item) => {
    //   var wrapper = item.querySelector(".toggle-product-carousel");
    //   var quantityWrapper = item.querySelector(".toggle-content");
    //   var quantityWrapperClose = item.querySelector(
    //     ".toggle-product-carousel-close"
    //   );
    //   wrapper.addEventListener("click", () => {
    //     quantityWrapper.classList.toggle("toggle-content-is-visible");
    //   });
    //   quantityWrapperClose.addEventListener("click", () => {
    //     quantityWrapper.classList.remove("toggle-content-is-visible");
    //   });
    // });
  },
});
